import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    justify-content: center;
    gap: 16px;
    margin-bottom: 16px;
    svg {
        width: 22px;
        height: 22px;
        fill: white;
    }

    .i-publish {
        font-size: 36px;
        color: white;
    }

    a {
        width: 36px;
        height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: ${p => p.theme.c.boost};
        border-radius: 21px;
    }
`;